export default "__VITE_ASSET__Dlt_nxzl__"